// extracted by mini-css-extract-plugin
export default {"formContent":"style_formContent__42E1M","breadCont":"style_breadCont__faT85","container":"style_container__ka9bz"};